import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comicData";

interface ComicCardProps {
  comic: Comic;
  size?: "normal" | "small";
}

export default function ComicCard({ comic, size = "normal" }: ComicCardProps) {
  const isSmall = size === "small";

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-xl bg-background-100 ${isSmall ? "aspect-[3/4]" : "aspect-[2/3]"}`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 韩漫免费漫画在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-white text-xs leading-relaxed line-clamp-3">
              {comic.description}
            </p>
          </div>
        </div>
        {comic.status === "已完结" && (
          <span className="absolute top-2 right-2 bg-black/70 text-white text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap">
            已完结
          </span>
        )}
        {comic.isHot && comic.status !== "已完结" && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap">
            热门
          </span>
        )}
        {comic.isNew && !comic.isHot && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-white text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap">
            新作
          </span>
        )}
      </div>

      <div className="mt-2.5 space-y-1">
        <h3 className={`font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors ${isSmall ? "text-sm" : "text-[15px]"}`}>
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{comic.author}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
          <span>{comic.status}</span>
        </div>
        {!isSmall && (
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-yellow-400 w-3 h-3 flex items-center justify-center"></i>
              {comic.rating}
            </span>
            <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
            <span>共{comic.totalChapters}话</span>
          </div>
        )}
      </div>
    </Link>
  );
}